import { VueTaxonomy } from '@oarepo/vue-taxonomy-editor'
import '@oarepo/vue-taxonomy-editor/styles.css'
import DefaultTaxonomyViewComponent from 'components/taxonomies/views/DefaultTaxonomyViewComponent.vue'
import PeriodTaxonomyViewComponent from 'components/taxonomies/views/PeriodTaxonomyViewComponent.vue'
import RequestorTaxonomyViewComponent from 'components/taxonomies/views/RequestorTaxonomyViewComponent.vue'
import InstitutionTaxonomyViewComponent from 'components/taxonomies/views/InstitutionTaxonomyViewComponent.vue'
import axios from 'axios'
import ExaminationMethodsTaxonomyViewComponent
  from '../components/taxonomies/views/ExaminationMethodsTaxonomyViewComponent'

export default async ({ Vue }) => {
  VueTaxonomy.install(Vue)
  await Vue.prototype.$taxonomies.loadTaxonomies('/api/taxonomies')
  Vue.prototype.$taxonomies.relevantTaxonomies = {
    '__all__': [
      'color',
      'period',
      'dimension',
      'requestors',
      'material-type',
      'restoration-technology',
      'fabrication-technology',
      'examination-methods'
    ],
    'keramika': [
      'period',
      'dimension',
      'requestors',
      'material-type',
      'fabrication-technology',
      'examination-methods'
    ],
    'kovy': [
      'period',
      'dimension',
      'requestors',
      'material-type',
      'restoration-technology',
      'fabrication-technology',
      'examination-methods'
    ],
    'sklo': [
      'color',
      'period',
      'dimension',
      'requestors',
      'material-type',
      'fabrication-technology',
      'examination-methods'
    ],
    'textil': [
      'period',
      'dimension',
      'requestors',
      'material-type',
      'restoration-technology',
      'fabrication-technology',
      'examination-methods'
    ],
    'ostatni': [
      'period',
      'dimension',
      'requestors',
      'material-type',
      'examination-methods'
    ]
  }
  Vue.prototype.$taxonomies.defaultViewer = DefaultTaxonomyViewComponent
  Vue.prototype.$taxonomies.addViewer('period', PeriodTaxonomyViewComponent)
  Vue.prototype.$taxonomies.addViewer('requestors', RequestorTaxonomyViewComponent)
  Vue.prototype.$taxonomies.addViewer('institutions', InstitutionTaxonomyViewComponent)
  Vue.prototype.$taxonomies.addViewer('examination-methods', ExaminationMethodsTaxonomyViewComponent)
  const periodTaxonomy = Vue.prototype.$taxonomies.taxonomies['period']
  if (!periodTaxonomy) {
    console.error('Could not load period taxonomy - is it installed?')
  } else {
    Vue.prototype.$taxonomies.periodTaxonomy = (await axios.get(periodTaxonomy.links.self)).data
  }
}
